import { InternshipLocationServiceInterface } from 'domain/services';
import { GetInternshipLocationUseCaseInterface } from 'domain/usecases';

export class InternshipLocationService
  implements InternshipLocationServiceInterface
{
  constructor(
    private readonly _getInternshipLocation: GetInternshipLocationUseCaseInterface,
  ) {}
  async getInternshipLocation(
    params: GetInternshipLocationUseCaseInterface.Params,
  ): Promise<GetInternshipLocationUseCaseInterface.Result> {
    return await this._getInternshipLocation.execute(params);
  }
}
